import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.element.classList.add("lp-reveal")
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return
      this.element.classList.add("is-visible")
      this.observer.disconnect()
    }, { threshold: 0.15, rootMargin: "0px 0px -80px 0px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
